import React from 'react';
import {BaseModal} from '../../comun/Index';
import { TextField, Autocomplete } from '@mui/material';

class Nueva extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      numero:'', 
      nombre:'', 
      distrito:'', 
      localidadSelec:null, 
      materiaSelec:null
    }
  }

  componentDidMount(){}

  guardar(){
    let datos = {
      numero:this.state.numero,
      nombre:this.state.nombre,
      distrito:this.state.distrito,
      localidad_id:this.state.localidadSelec.id,
      materia_id: this.state.materiaSelec.id,
    }
    this.props.guardar(datos);
  }

  render(){
    const {numero, nombre, distrito, localidadSelec, materiaSelec} = this.state;
    const {localidades, materias} = this.props;
    return(
      <BaseModal
        titulo="Datos de Usuario"
        loading={false}
        botonera={[
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
          {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => this.guardar()}
        ]}
      >
        <div className="Seccion" style={{width:'90%'}}>
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            inputProps={{style:{textAlign:'center'}}}
            label="N° de juzgado"
            value={numero}
            onChange={(e) => this.setState({numero:e.target.value})}
            variant="outlined"
          />
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            inputProps={{style:{textAlign:'center'}}}
            label="Nombre"
            value={nombre}
            onChange={(e) => this.setState({nombre:e.target.value})}
            variant="outlined"
          />
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            inputProps={{style:{textAlign:'center'}}}
            label="Distrito"
            value={distrito}
            onChange={(e) => this.setState({distrito:e.target.value})}
            variant="outlined"
          />
        </div>
        <div className="Seccion" style={{width:'90%'}}>
          <Autocomplete
            value={localidadSelec}
            onChange={(e,n) => this.setState({localidadSelec:n})}
            isOptionEqualToValue={(option, value) => option.id === value.id }
            slotProps={{style:{textAlign:'center'}}}
            options={localidades}
            getOptionLabel={(option) => option.descripcion}
            size="small"
            disableClearable
            style={{margin:'5px 1px',flex:1, fontSize:5}}
            fontSize="small"
            renderInput={(params) => <TextField {...params} label="Localidad"/>}
          />
          <Autocomplete
            value={materiaSelec}
            onChange={(e,n) => this.setState({materiaSelec:n})}
            isOptionEqualToValue={(option, value) => option.id === value.id }
            slotProps={{style:{textAlign:'center'}}}
            options={materias}
            getOptionLabel={(option) => option.nombre}
            size="small"
            disableClearable
            style={{margin:'5px 1px',flex:1, fontSize:5}}
            fontSize="small"
            renderInput={(params) => <TextField {...params} label="Materias"/>}
          />
        </div>
      </BaseModal>
    );
  }
}

export default Nueva;
